"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetTheHouseAbilityHandler = exports.BetTheHouseActorAbilityFactory = exports.BetTheHouseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AttributeType_1 = require("../../core/enums/AttributeType");
const core_2 = require("../../core/effects/core");
const core_3 = require("../../core/actions/core");
const Enum_1 = require("../../utils/Enum");
class BetTheHouseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BetTheHouse;
        this.__typeName = "BetTheHouse";
    }
}
exports.BetTheHouseAbilityArgs = BetTheHouseAbilityArgs;
let BetTheHouseActorAbilityFactory = class BetTheHouseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BetTheHouse", "AllAllies", 4);
    }
};
BetTheHouseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BetTheHouse")
], BetTheHouseActorAbilityFactory);
exports.BetTheHouseActorAbilityFactory = BetTheHouseActorAbilityFactory;
let BetTheHouseAbilityHandler = class BetTheHouseAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                if (!container.testAttribute(ability.invokerId, "Luck", 50)) {
                    container.dispatch(sequence, ability.invokerId, new core_3.SpeakTextActionArgs((0, Random_1.randomElement)([
                        "Bust!",
                        "I Fold..."
                    ])));
                    return;
                }
                if (container.testAttribute(ability.invokerId, "Luck", 50)) {
                    container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .forEach(allyId => {
                        container.applyBuff({
                            sequence: sequence.pushSequence("sequential"),
                            creatorId: ability.invokerId,
                            targetId: allyId,
                            duration: Duration_1.Duration.Permanent,
                            effect: new core_2.LinkedEffectsEffectArgs(Array.from(AttributeType_1.PRIMARY_ATTRIBUTES)
                                .map(attr => new core_2.MaxAttributeIncreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(allyId, 50, (0, Enum_1.enumKey)(AttributeType_1.AttributeType, attr)))), false),
                            onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "FireMagicCircle"))
                        });
                    });
                }
                else {
                    container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                        .forEach(targetId => {
                        container.applyDebuff({
                            sequence: sequence.pushSequence("sequential"),
                            attackerId: ability.invokerId,
                            targetId,
                            duration: Duration_1.Duration.Permanent,
                            effect: new core_2.LinkedEffectsEffectArgs(Array.from(AttributeType_1.PRIMARY_ATTRIBUTES)
                                .map(attr => new core_2.MaxAttributeDecreaseEffectArgs(attr, container.getPercentOfBaseAttributeScore(targetId, 50, (0, Enum_1.enumKey)(AttributeType_1.AttributeType, attr)))), true),
                            onAppliedOrResisted: (sequence, _, applied) => sequence.push(new core_1.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "EngulfingDarkness"))
                        });
                    });
                }
            }
        });
    }
};
BetTheHouseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BetTheHouse)
], BetTheHouseAbilityHandler);
exports.BetTheHouseAbilityHandler = BetTheHouseAbilityHandler;
